import { faNewspaper, faThumbsUp } from "@fortawesome/pro-regular-svg-icons";
import { faStar, faTh, faUsers } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Img } from "@/mk2/components/Img";
import { Link } from "@/mk2/components/Link";
import { NotificationsBadge } from "@/mk2/components/NotificationsBadge";
import { pageheaderRefreshFeedMenu } from "@/mk2/containers/PageHeader/PageHeader.action";
import { FeedItem, MenuItem } from "@/mk2/containers/PageHeader/PageHeader.reducers";
import { MapDispatchToPropsObject } from "@/mk2/helpers/types";
import { AppState, getResponseRenderedAt } from "@/mk2/reducers";
import assetUrl from "@/mk/common/assetUrl";

import styles from "./GroupsMenu.mscss";

const ICONS = {
    "far fa-newspaper": faNewspaper,
    "far fa-thumbs-up": faThumbsUp,
    "fa-users": faUsers,
    "fa-th": faTh,
};

interface OwnProps {
    className?: string;
    feedMenu: MenuItem[];
    currentUrl: string;
    isMobile: boolean;
    requestUserPermissions?: string[];
    section?: string;
}

interface StateProps {
    renderedAt: number;
}

interface DispatchProps {
    onRefresh();
}

type Props = OwnProps & StateProps & DispatchProps;

const GroupsMenuComponent: React.FunctionComponent<Props> = ({
    className,
    feedMenu,
    currentUrl,
    isMobile,
    requestUserPermissions,
    section,
    renderedAt,
    onRefresh,
}) => {
    const isBlogsAdmin =
        requestUserPermissions && requestUserPermissions.indexOf("photoblog.can_manage_blogs") >= 0;
    const isForumAdmin =
        requestUserPermissions && requestUserPermissions.indexOf("forum.can_manage_forum") >= 0;

    let myActivity =
        isMobile &&
        feedMenu.find((item) => item.name === "my-activity" && item.section === "forum_and_groups");
    myActivity = myActivity && { ...myActivity, icon: assetUrl + "img/icons/icon-gray-thumb.png" };
    const flagged = isBlogsAdmin && isMobile && feedMenu.find((item) => item.name === "flagged");
    const flaggedGroups = isForumAdmin && feedMenu.find((item) => item.name === "flagged-groups");

    useEffect(() => {
        // After 30s after initial page load refresh feedMenu on mount
        if (renderedAt + 30 * 1000 < Date.now()) {
            onRefresh();
        }
    }, [onRefresh, renderedAt]);

    return (
        <div className={cx(styles.GroupsMenu, className)}>
            {myActivity && (
                <Item
                    item={myActivity}
                    selected={myActivity.url === currentUrl || myActivity.url2 === currentUrl}
                />
            )}

            {flagged && <Item item={flagged} selected={flagged.url === currentUrl} />}

            {flaggedGroups && (
                <Item item={flaggedGroups} selected={flaggedGroups.url === currentUrl} />
            )}

            {feedMenu.map((item) =>
                item.isGroup
                    ? (item.section === null || item.section === section) &&
                      item.items.length > 0 && (
                          <div key={item.title}>
                              <h2 className={styles.GroupsMenu__title}>
                                  {item.icon === "fa-star" && (
                                      <div className={styles.GroupsMenu__link__star}>
                                          <FontAwesomeIcon icon={faStar} />
                                      </div>
                                  )}
                                  {item.title}
                              </h2>
                              {item.items.map((groupItem) => (
                                  <Item
                                      key={groupItem.name}
                                      item={groupItem}
                                      selected={currentUrl.startsWith(groupItem.url)}
                                  />
                              ))}
                          </div>
                      )
                    : item.name !== "flagged" &&
                      item.name !== "flagged-groups" &&
                      item.name !== "feeds" && // TODO: Something is really wrong here
                      (item.section === null || item.section === section) && (
                          <Item
                              key={item.title}
                              item={item}
                              selected={
                                  item.url === currentUrl ||
                                  item.url2 === currentUrl ||
                                  item.url3 === currentUrl
                              }
                          />
                      ),
            )}
        </div>
    );
};

GroupsMenuComponent.displayName = "GroupsMenu";

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        renderedAt: getResponseRenderedAt(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onRefresh: pageheaderRefreshFeedMenu,
};

export const GroupsMenu = connect(mapStateToProps, mapDispatchToProps)(GroupsMenuComponent);

interface MenuItemOwnProps {
    item: FeedItem;
    selected: boolean;
}

let Item: React.FunctionComponent<MenuItemOwnProps> = ({ item, selected }) => (
    <Link
        className={cx(
            styles.GroupsMenu__link,
            item.title === "Flagged" ? styles["GroupsMenu__link--flagged"] : null,
            selected && styles["GroupsMenu__link--selected"],
            "topmenu-mobilemenuGroupLink",
        )}
        to={item.url}
    >
        {item.icon ? (
            item.icon.startsWith("fa") ? (
                <div className={styles.GroupsMenu__link__icon}>
                    <FontAwesomeIcon icon={ICONS[item.icon]} />
                </div>
            ) : (
                <Img
                    alt=""
                    className={styles.GroupsMenu__link__newIconImg}
                    src={item.icon}
                    width={18}
                    height={16}
                />
            )
        ) : null}
        <span>{item.title}</span>
        <NotificationsBadge
            className={styles.GroupsMenu__notificationsBadge}
            count={item.lastVisitCount}
        />
    </Link>
);

Item.displayName = "Item";
Item = React.memo<MenuItemOwnProps>(Item);
